import Layout from "../components/Layout";
import { ResearchList } from "../components/Entries";
import { research } from "../content/writing";
import ProfileIntro from "../components/ProfileIntro";
import styles from "../styles/Site.module.css";

const Home = () => {
    return (
        <Layout>
            <ProfileIntro />
            <h2 className={styles.sectionTitle}>Research</h2>
            <ResearchList items={research} />
        </Layout>
    );
};

export default Home;
